let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fu9jF")).then(() => parcelRequire('jYquo'));